import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_URL} from '../../constants/apiUrls';
import {
  GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_QUERY_KEY
} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface DownloadSummaryResponse {
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: DownloadSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalDownloadSummary = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalDownloadSummary = async () => {
    const res = await axiosClient.get<DownloadSummaryResponse>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_QUERY_KEY,
      getNonNationalDownloadSummary,
      {
        onSuccess,
        onError,
        enabled: false,
      }
  );
};
